import React, { useCallback } from 'react';
import cn from 'classnames';

import { ModalContext } from 'components/core/ModalRoot.component';
import MenuBanner from 'components/menu/MenuBanner.component';
import ReleaseInfoBox from 'components/menu/ReleaseInfoBox.component';
import RELEASE from 'config/release.singleton';
import { useTheme } from 'providers/Theme.provider';

import ConfirmationDialog from 'scheduler/components/ConfirmationDialog';

import CN from './ReleaseMenuBanner.module.scss';

export const ReleaseMenuBanner = () => {
  const { isDarkMode } = useTheme();
  const handleLeft = useCallback((ev) => {
    RELEASE.reload();
    ev?.onRequestClose?.();
  }, []);

  const handleClick = useCallback(
    (ev) =>
      ev?.showModal?.(
        ({ onRequestClose }) => (
          <ConfirmationDialog
            onRequestClose={onRequestClose}
            title="Version"
            leftButtonText="RELOAD PAGE"
            onLeft={() => handleLeft({ onRequestClose })}
            rightButtonText="OK"
            onRight={onRequestClose}
            onCancel={onRequestClose}
          >
            <ReleaseInfoBox extended />
          </ConfirmationDialog>
        ),
        {},
      ),
    [handleLeft],
  );

  return (
    <MenuBanner>
      <ModalContext.Consumer>
        {({ showModal }) => (
          <div
            data-bem="ReleaseMenuBanner"
            className={cn({
              [CN.component]: true,
              [CN.darkMode]: isDarkMode,
            })}
            aria-current="true"
            role="link"
            tabIndex="0"
            onClick={() => void handleClick({ showModal })}
          >
            <span className={CN.textBold}>
              Version ID: <ReleaseInfoBox />
            </span>
          </div>
        )}
      </ModalContext.Consumer>
    </MenuBanner>
  );
};
